import { MAX_VISIBLE_SELECTED_WORK_ITEMS } from '../../common/constants/display-context';

type SelectedWorkItemCountBucket = '0' | '1' | '2-5' | '6+';

export const getSelectedWorkItemCountBucket = (itemCount: number): SelectedWorkItemCountBucket => {
	if (itemCount <= 0) {
		return '0';
	}
	if (itemCount === 1) {
		return '1';
	}
	if (itemCount <= MAX_VISIBLE_SELECTED_WORK_ITEMS) {
		return '2-5';
	}
	return '6+';
};
